<template>
  <div class="inventoryPage">
    <div class="card-header">
      <a @click="goToPlans" class="prevButton backArrow mr-2" data-dismiss="modal">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
          style="enable-background:new 0 0 512 512;"
          xml:space="preserve"
        >
          <g>
            <g>
              <path
                d="M501.333,245.333H36.417l141.792-141.792c4.167-4.167,4.167-10.917,0-15.083c-4.167-4.167-10.917-4.167-15.083,0l-160,160
              c-4.167,4.167-4.167,10.917,0,15.083l160,160c2.083,2.083,4.813,3.125,7.542,3.125c2.729,0,5.458-1.042,7.542-3.125
              c4.167-4.167,4.167-10.917,0-15.083L36.417,266.667h464.917c5.896,0,10.667-4.771,10.667-10.667S507.229,245.333,501.333,245.333z
              "
              />
            </g>
          </g>
        </svg>
      </a>Back to Plans
    </div>
    <div class="card-body">
      <div class="outer-wrapper">
        <div class="container-fluid">
          <div class="row justify-content-center">
            <div class="col-md-3">
              <div class="p-4 bg-light elevation-3 rounded mt-4">
                <h3>{{projectName}}</h3>
                <div class="grid-holder">
                  <span class="title">Typology</span>
                  <span class="titleDetails">{{selectedTypology.value}}</span>
                </div>
                <div class="grid-holder">
                  <span class="title">Floor Range</span>
                  <span class="titleDetails">{{selectedFloor.value}}</span>
                </div>
                <div class="grid-holder">
                  <span class="title">Saleable Area</span>
                  <span class="titleDetails">{{selectedTypology.area}} Sq.Ft.</span>
                </div>
                <div class="grid-holder">
                  <span class="title">Price</span>
                  <span class="titleDetails">₹ {{selectedTypology.priceRange}} Cr</span>
                </div>
              </div>
            </div>
            <div class="ct-col col-md-9">
              <div class="p-4 b-2 rounded">
                <div>
                  <b-tabs content-class="mt-3 " pills>
                    <b-tab v-for="(wing, key) in wings" :key="key" :active="key === 0" :title="wing.name">
                      <div class="card tabInventory" v-for="(flats, floor, flKey) in groupByFloor(wing.flats)" :key="flKey">
                        <div class="card-header">{{floor}}</div>
                        <div class="card-body">
                          <a v-for="(flat, fKey) in flats"
                            :key="fKey"
                            class="flat-grid-holder"
                            @click="flat.status === 'Available' && selectFlat(flat, wing)"
                            href="javascript:void(0)"
                          >
                            <div class="flat-grid" :class="getFlatClass(flat.status)" v-b-popover.hover.top="availText(flat)">
                              <p class="inner-text">
                                Flat :
                                <strong class>{{flat.name}}</strong>
                              </p>
                            </div>
                          </a>
                        </div>
                      </div>
                    </b-tab>
                  </b-tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DetailModal :selectedWing="selectedWing" :selectedFlat="selectedFlat" />
  </div>
</template>
<script>
import { masterJson, projectName } from "@/assets/scripts/utility.js";
import DetailModal from '@/components/Inventory/Details.vue';
export default {
  components: {
    DetailModal
  },
  data(){
    return {
      selectedWing: {},
      selectedFlat: {}
    }
  },
  created() {
    let selectedFloor = masterJson.Floors.find(
      (k) => k.key === this.$route.params.floor
    );
    if (selectedFloor) {
      this.$store.dispatch("setFloor", selectedFloor);
    }
    let selectedTypology = masterJson.Typologies.find(
      (k) => k.key === this.$route.params.typology
    );
    if (selectedTypology) {
      this.$store.dispatch("setTypology", selectedTypology);
    }
  },
  methods: {
    goToPlans(){
      this.$router.push({name: 'Plans', params: {typology: this.selectedTypology.key, floor: this.selectedFloor.key}})
    },
    groupByFloor(flats){
      return this.$_.groupBy(flats, 'floor')
    },
    availText(flat){
      if(flat.status === "Available"){
        return "Click To Book!"
      }else if(flat.status === "Booked"){
        return "Flat Booked"
      }else if(flat.status === "Blocked"){
        return "Flat Blocked"
      }
    },
    getFlatClass(status){
      if(status === 'Available'){
        return 'flat-available';
      }else if(status === 'Booked'){
        return 'flat-booked';
      }else if(status === 'Blocked'){
        return 'flat-blocked';
      }
    },
    selectFlat(flat, wing){
      if(flat.status === "Available"){
        this.selectedFlat = flat
        this.selectedWing = wing
        this.$bvModal.show('modal-inventory-details')
      }
    }
  },
  computed: {
    selectedTypology() {
      return this.$store.getters.selectedTypology;
    },
    selectedFloor() {
      return this.$store.getters.selectedFloor;
    },
    projectName(){
      return projectName;
    },
    wings(){
      return masterJson.Wings
    }
  },
};
</script>